import { State } from '../models/states.model';
import { ListItem } from '../models/ListItem';
import GenericService from './genericService';
import { httpService } from './httpService';

class StatesService extends GenericService<State, ListItem> {
  constructor() {
    super('/api/States');
  }
  async getByCountryId(id: number | string): Promise<State[]> {
            return await httpService.get<State[]>(`/api/States/GetByCountry/${id}`, undefined, {
                unwrap: true,
                normalize: true,
                toast: false,
            });
        }
}

export const statesService = new StatesService();
